import APIService from '@/services/APIService';

export default {
  // index(id) {
  //   return APIService.get(`/user/${id}/notifications`);
  // },
  index(params) {
    return APIService.get('/notifications', params);
  },
  readNotification(params) {
    return APIService.post('/notifications/read', params);
  },
  getSubscribes(params) {
    return APIService.get('/notifications-subscribes', params);
  },
  setSubscribes(params) {
    return APIService.post('/notifications-subscribes', params);
  },
  unSetSubscribe(params) {
    return APIService.post('/notifications-subscribes/delete', params);
  },
};
